import { DialogProps } from '@reach/dialog';
import { Dialog } from 'components/ui';
import { MarketplaceListingAlert } from 'lib/api/generated';
import { FC, useState } from 'react';
import { MarketplaceNotificationBody } from './marketplace-notification-body';
import { SetUpNotificationSteps } from './marketplace-notification-utils';

export interface MarketplaceNotificationDialogProps extends DialogProps {
  onDismiss?: () => void;
  onDelete?: () => void;
}

export const MarketplaceNotificationDialog: FC<
  MarketplaceNotificationDialogProps
> = ({ onDismiss, isOpen }) => {
  const [selected, setSelected] = useState<MarketplaceListingAlert>();
  const [step, setStep] = useState<SetUpNotificationSteps>(
    SetUpNotificationSteps.selectCategories
  );
  return (
    <Dialog
      title={selected?.name || 'Notifications'}
      onDismiss={() => {
        onDismiss?.();
        setSelected(undefined);
        setStep(SetUpNotificationSteps.selectCategories);
      }}
      isOpen={isOpen}
    >
      <MarketplaceNotificationBody
        step={step}
        setStep={setStep}
        selected={selected}
        setSelected={setSelected}
      />
    </Dialog>
  );
};
